import { connect } from 'react-redux';
import {
  sessionViewSelectors,
  setLeftPanelDeviceUid,
  setLeftPanelType,
} from '../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../redux/store';
import {
  diagramSelectors,
  setDeviceIdToConfigureInDiagram,
  setSelectedNodeToDelete,
} from '../../../../redux/diagram/slice';
import {
  logicalConnectionsSelectors,
  setIsDrawingLogicalConnectionFrom,
} from '../../../../redux/logicalConnections/slice';
import { getCurrentUserState } from '../../../../redux/configuration/currentUser/slice';
import { determineIsEditHardwareAllowed } from './utils/utils';
import { HardwareNode } from '.';

const mapDispatchToProps = {
  setDeviceIdToConfigureInDiagram,
  setIsDrawingLogicalConnectionFrom,
  setLeftPanelDeviceUid,
  setLeftPanelType,
  setSelectedNodeToDelete,
};

type OwnProps = {
  isReadOnly: boolean;
};

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
  expired: sessionViewSelectors.getExpired(state),
  isAddingLogicalConnection:
    diagramSelectors.getIsAddingLogicalConnection(state),
  isDrawingLogicalConnectionFrom:
    logicalConnectionsSelectors.getIsDrawingLogicalConnectionFrom(state),
  isEditAllowed: determineIsEditHardwareAllowed({
    isReadOnly: ownProps.isReadOnly,
    userRoles: getCurrentUserState(state).userRoles || [],
  }),
  isSnapToGridEnabled: diagramSelectors.getIsSnapToGridEnabled(state),
});

interface HardwareNodeAssetProps extends BaseNodeProps {
  asset?: Hardware;
  iconName?: string;
}

export type HardwareNodeProps = typeof mapDispatchToProps &
  ReturnType<typeof mapStateToProps> &
  HardwareNodeAssetProps;

export const HardwareNodeContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HardwareNode);
